import React, { useState } from 'react';
import metrics from './internetMetrics';
import { Accordion } from 'react-bootstrap';

export default function TaxonomyFilters({ filters, counts, checkedFilters, onFilterChange }) {
	// force filters to be an object
	filters = Object.assign({}, filters);
	const [showAll, setShowAll] = useState({});

	const toggleShowAll = (filterName) => {
		setShowAll((prev) => ({ ...prev, [filterName]: !prev[filterName] }));
	};

	const handleCheckboxChange = (filterName, option, isChecked) => {
		metrics.event(null, `cdcsitesearch-filter-${filterName}`);
		if (onFilterChange) {
			onFilterChange(filterName, option, isChecked);
		}
	};

	const handleKeyPress = (e, filterName, option) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			const isChecked = checkedFilters[filterName]?.includes(option) || false;
			onFilterChange(filterName, option, !isChecked);
		}
	};

	const renderCheckboxFilter = (filterName, options, index) => {
		if (!filters || filters[filterName].length < 1) {
			return null;
		}

		const showAllOptions = showAll[filterName];
		const checkedOptions = options.filter((option) => checkedFilters[filterName].includes(option));
		const uncheckedOptions = options.filter((option) => !checkedFilters[filterName].includes(option));
		const sortedOptions = [...checkedOptions, ...uncheckedOptions];
		const visibleOptions = showAllOptions ? sortedOptions : sortedOptions.slice(0, 10);

		return (
			<Accordion.Item eventKey={index.toString()} key={`accordion-${filterName}`}>
			<div className='search-filters-header-container'>
				<Accordion.Header className="search-filters-header-title">{filterName}</Accordion.Header>
			</div>
				<Accordion.Body>
					<div className="search-filters-taxonomy-list-container">
						{visibleOptions.map((option) => (
							<div key={option} className="search-filters__input">
								<input
									type="checkbox"
									id={`${filterName}-${option}`}
									className="search-filters-option"
									checked={checkedFilters[filterName]?.includes(option) || false}
									onChange={(e) => handleCheckboxChange(filterName, option, e.target.checked)}
									onKeyDown={(e) => handleKeyPress(e, filterName, option)}
								/>
								<label htmlFor={`${filterName}-${option}`} className="search-filters-label">
									{option}{' '}
								</label>
								<span className="search-filters__count">
									({counts[filterName]?.[option] || 0})
								</span>
							</div>
						))}
					</div>

					{options.length > 10 && (
						<button className={`${showAllOptions ? 'search-filters-show-button--active' : ''} search-filters-show-button`} onClick={() => toggleShowAll(filterName)}>
							{showAllOptions ? 'Show Less ' : 'Show More '} <i className={`cdc-fa-angle-${showAllOptions ? 'up' : 'down'}`}></i>
						</button>
					)}
				</Accordion.Body>
			</Accordion.Item>
		);
	};

	return (
		<div className="search-filters-container">
			<Accordion
				alwaysOpen
				defaultActiveKey={Object.keys(filters).map((_, index) => index.toString())}
				key={Object.keys(filters).join(',')}
				className="search-filters"
			>
				{Object.keys(filters).map((filterName, index) =>
					renderCheckboxFilter(filterName, filters[filterName], index)
				)}
			</Accordion>
		</div>
	);
}
